/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import CollapseComponent from "../Common/Collapse.js";
import PromoplanComponent from "../Company/Promoplan.js";
import { Row, Col } from 'react-grid-system';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Cookies from 'universal-cookie';
import ReactPlayer from 'react-player';
import MetaTags from 'react-meta-tags';

let obj = {
  "voicefilter": 1,
  "broadcastAssistant": 2,
  "aichatbot": 3
}
let urlWhiteList = [
  "https://ibobbyweb.ai.hinet.net",
  "https://ibobbyweb-stg.ai.hinet.net",
  "https://ibobby.ai.hinet.net",
  "https://ibobby-stg.ai.hinet.net",
  "localhost",
  "voicefilter",
  "broadcastAssistant",
  "aichatbot"
]

function productMapping(product) {
  return obj[product];
}

function sortEntList(allEnt) {
  let result = [];
  for (var k in obj) {
    for (let i = 0; i < allEnt.length; i++) {
      if (obj[k] === allEnt[i].ent_id) {
        result.push(allEnt[i]);
        break;
      }
    }
  }
  return result;
}

function Company() {
  const [curEnt, setEnt] = useState(null);
  const [allEnt, setAllEnt] = useState(null);
  const [listItems, setListItem] = useState(null);
  const [screenClass, setScreenClass] = useState(null);
  const [promoplainObj, setPromoplainObj] = useState(null);

  let { product } = useParams();
  const location = useLocation();
  const cookies = new Cookies();
  const navigate = useNavigate();

  let apiUrl = "/ENT/List"; //開f12監控網頁後會發現此API怪怪的
  let apiParams = {
    "access_token": cookies.get("auth_access_token")
  };
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(apiParams)
  };

  function checkScreenSize() {
    var windowWidth = window.innerWidth;
    if (windowWidth >= 3000)
      setScreenClass("pagesize_ent_40");
    else if (windowWidth >= 1880 && windowWidth < 3000)
      setScreenClass("pagesize_ent_60");
    else if (windowWidth < 1880)
      setScreenClass("pagesize_ent_98");
  }

  function filterXSSScript(m) {
    var lt = /</g,
      gt = />/g,
      ap = /'/g,
      ic = /"/g;
    let result = m.toString().replace(lt, "&lt;").replace(gt, "&gt;").replace(ap, "&#39;").replace(ic, "&#34;");
    return result;
  }

  function checkWhite() {
    let message = ""
    for (var i = 0; i < urlWhiteList.length; i++) {
      if (product.includes(urlWhiteList[i])) {
        product = filterXSSScript(product);
        message = <li><a href={"/company/" + product}>延伸應用 / {curEnt.ent_name}</a></li>
        break;
      }
    }
    return message
  }

  const MetaData = (props) => {
    let result = null;
    if (props.page === 1) {
      result = <MetaTags>
                <title>中華電信AI語意雲延伸應用-聲音濾鏡</title>
                <meta name="keywords" content="音轉字,語音轉文字,上字幕,逐字稿,剪片上字幕,聽打,語音辨識,語音轉文字,聲音轉字,錄音檔轉字,音轉字軟體,影片上字幕,即時字幕,AI上字幕,STT,speech to text"></meta>
                <meta name="description" content="AI聲音濾鏡提供一站式雲端線上音轉字服務，為中華電信自主開發之AI語音辨識技術，提供最在地化的「國語」語音轉文字服務；音檔轉出後之文字與熱詞資訊供線上修編，提供加值應用服務。" />
                <meta property="og:title" content="中華電信AI語意雲延伸應用-聲音濾鏡" />
                <meta property="og:Description" content="AI聲音濾鏡提供一站式雲端線上音轉字服務，為中華電信自主開發之AI語音辨識技術，提供最在地化的「國語」語音轉文字服務；音檔轉出後之文字與熱詞資訊供線上修編，提供加值應用服務。" />
                <meta property="og:image" content="https://voicefilter.ai.hinet.net/AdminLTE/dist/img/CHTLogo_login.png" />
              </MetaTags>
    } else if (props.page === 2) {
      result = <MetaTags>
                <title>中華電信AI語意雲延伸應用-廣播助理</title>
                <meta name="keywords" content="大聲公,TTS,文字轉語音,排程推播,定時推播,聲音推播,語音合成,仿聲,聲音模仿,語音製作,Text To Speech"></meta>
                <meta name="description" content="將要傳達給用戶的訊息在特定的時間推播給特定的裝置或群組，支援將文字轉換成人類自然發聲的音訊及模仿特定人物發音。" />
                <meta property="og:title" content="中華電信AI語意雲延伸應用-廣播助理" />
                <meta property="og:Description" content="將要傳達給用戶的訊息在特定的時間推播給特定的裝置或群組，支援將文字轉換成人類自然發聲的音訊及模仿特定人物發音。" />
                <meta property="og:image" content="https://ibobby.ai.hinet.net/app_icons/app_banner/imgUpload_b4d602d1-1faf-4c72-9a3a-fc1580dbc72a.png" />
              </MetaTags>
    } else if (props.page === 3) {
      result = <MetaTags>
                <title>中華電信AI語意雲延伸應用-知識中心</title>
                <meta name="keywords" content="AI線上客服、AI chatbot、chatbot、聊天機器人、對話機器人"></meta>
                <meta name="description" content="導入AI自然語意理解模型，對企業內部則可以做為專業知識庫，提供內部人員解決重複常態性問答；對企業外部及SOHO族皆可以提供客戶問答服務，讓服務24小時不間斷，成為您最貼心又聰明的得力助手！" />
                <meta property="og:title" content="中華電信AI語意雲延伸應用-知識中心" />
                <meta property="og:Description" content="導入AI自然語意理解模型，對企業內部則可以做為專業知識庫，提供內部人員解決重複常態性問答；對企業外部及SOHO族皆可以提供客戶問答服務，讓服務24小時不間斷，成為您最貼心又聰明的得力助手！" />
                <meta property="og:image" content="https://ibobby.ai.hinet.net/app_icons/app_banner/imgUpload_21740aa5-058f-4103-a7f9-3dce275eb005.png" />
              </MetaTags>
    }
    return result;
  }

  window.onresize = function () {
    checkScreenSize();
  }

  let imgApi = process.env.REACT_APP_IMG_API;

  useEffect(() => {
    const script = document.createElement('script');
    if (process.env.REACT_APP_DEV_ENV === "dev")
      script.src = "https://s3.hicloud.net.tw/cpmaker-stg/b75aff59-2634-45b2-ae41-764f60b1bbc2.js";
    else if (process.env.REACT_APP_DEV_ENV === "stage")
      script.src = "https://s3.hicloud.net.tw/cpmaker-stg/b75aff59-2634-45b2-ae41-764f60b1bbc2.js";
    else if (process.env.REACT_APP_DEV_ENV === "prod")
      script.src = "https://s3.hicloud.net.tw/cpmaker/988fa3ee-e5ef-4bf9-82ff-32f2ea832f16.js";

    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }
  }, []);

  // 取得企客專區產品ent_id & ent_name
  useEffect(() => {
    checkScreenSize();
    fetch("/api" + apiUrl, requestOptions)
      .then(res => res.json())
      .then((result) => {
        // console.log("enterprise list => " + JSON.stringify(result));
        if (result.isSuccess === 0 && result.errMsg.includes("驗證失敗")) {
          window.alert("網頁過期，請重新登入");
          navigate("/logout");
        }
        let items = result.results;
        items = sortEntList(items);
        let curEntID = 0;
        setAllEnt(items);
        for (let i = 0; i < items.length; i++) {
          if (items[i].ent_id === productMapping(product)) {
            items[i].product = product;
            setEnt({ ...items[i] });
            curEntID = items[i].ent_id;
          }
        }

        apiUrl = "/ENT/Detail";
        apiParams = {
          "access_token": cookies.get("auth_access_token"),
          "ent_id": curEntID
        };
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(apiParams)
        };
        fetch("/api" + apiUrl, requestOptions)
          // fetch(process.env.REACT_APP_API+apiUrl,requestOptions)
          .then(res => res.json())
          .then((result) => {
            setListItem(result.results);
          }).catch(err => {
            throw new Error(err)
          })
      }).catch(err => {
        throw new Error(err)
      })
  }, [location])

  useEffect(() => {
    // fetch("/apt/landing/"+filterXSSScript(product) )
    fetch(process.env.REACT_APP_LANDING_API + filterXSSScript(product))
      .then(res => res.json())
      .then((result) => {
        //   console.log(result);

        // setListItem(result);

      }).catch(err => {
        throw new Error(err)
      })
  }, [location])

  return (
    <>
    <img src={require("../../image/ibobby_RIP_small.png").default} alt="RIPImage" class="onTopRIP"></img>
      {allEnt && curEnt && listItems ?
        <>
          <MetaData page={curEnt.ent_id} />
          <div className="vision_con">
            <div className="vc_img vc_w"><img src={require("../../image/img_vision_06_" + curEnt.ent_id + "_w.png").default} alt="img_vision_04_w"></img></div>
            <div className="vc_img vc_m"><img src={require("../../image/img_vision_06_" + curEnt.ent_id + "_m.png").default} alt="img_vision_04_m"></img></div>
          </div>
          <div className="content_inpage">
            <div className={screenClass}>
              <ul className="bread">
                <li><a href="/">首頁</a></li>
                {checkWhite()}
              </ul>
              <div className="tab_con">
                <div className="tab_box active">
                  <h2 className="tit_main">{curEnt.ent_name}</h2>
                  <div className="content_box discount_box">
                    {/* 收折快速引導至各產品及優惠方案Component */}
                    <CollapseComponent promoplainObj={promoplainObj} allEnt={allEnt} curEnt={curEnt} />

                    {/* 放置banner */}
                    {/* <Row>
                  <Col xs={12}>
                  <img src={require("../../image/img_si_more.png").default} />
                  </Col>
                </Row> */}
                    <div style={{ padding: "0 20px 0 20px", marginTop: "15px" }}>
                      {listItems.map((item, index) =>

                        /* landing page說明文字，cell: 圖片(4) 文字(8) */
                        /*  奇數左圖右文字，偶數左文字右圖*/
                        ((index + 1) % 2 === 0) ?
                          <Row key={index}>
                            <Col sm={6} md={8}>
                              <Row>
                                <Col xs={12}>
                                  <h2>{item.ent_title}</h2>
                                </Col>
                                <Col xs={12}>
                                  <h4>{item.ent_content}</h4>
                                </Col>
                                <Col xs={12}>
                                  <h6>{item.ent_detail}</h6>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm={6} md={4}>
                              <img src={imgApi + item.ent_image} width="320px" alt=""></img>
                            </Col>
                          </Row>
                          :
                          <Row key={index}>
                            <Col sm={6} md={4}>
                              <img src={imgApi + item.ent_image} width="320px" alt=""></img>
                            </Col>
                            <Col sm={6} md={8}>
                              <Row>
                                <Col xs={12}>
                                  <h2>{item.ent_title}</h2>
                                </Col>
                                <Col xs={12}>
                                  <h4>{item.ent_content}</h4>
                                </Col>
                                <Col xs={12}>
                                  <h6>{item.ent_detail}</h6>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                      )}
                    </div>

                    <Row >
                      <Col xs={1}></Col>
                      <Col xs={10}>
                        {/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
                        {/* <ReactPlayer muted={true} controls={true} playing={true} url={(curEnt.ent_id !== 1)? process.env.REACT_APP_FILM_API + listItems[0].ent_film : "https://www.youtube.com/watch?v=l1QKPU01fj8"} width="100%" height="600px" /> */}
                      </Col>
                      <Col xs={1}></Col>
                    </Row>

                    {/* 優惠方案case */}
                    <PromoplanComponent curEnt={curEnt} setPromoplainObj={setPromoplainObj}></PromoplanComponent>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
        : <div></div>
      }
    </>
  )
}

export default Company;